import React from 'react';

interface LearningCardProps {
    previewImageUri: string;
    showPlay: boolean;
    className?: string;
}

export function LearningCard({ previewImageUri, showPlay, className }: LearningCardProps) {
    return (
        <div className={className}>
            {showPlay && (
                <button className='relative'>
                    <img src={previewImageUri} alt='Learning Material Preview' className='w-full' />
                    <div className='absolute inset-0 flex items-center justify-center'>
                        <svg
                            width='64'
                            height='64'
                            viewBox='0 0 64 64'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className='text-white'
                        >
                            <circle cx='32' cy='32' r='32' fill='rgba(0, 0, 0, 0.5)' />
                            <path d='M26 20L42 32L26 44V20Z' fill='white' className='[&:not(.no-fill)]:fill-white' />
                        </svg>
                    </div>
                </button>
            )}
            {!showPlay && <img src={previewImageUri} alt='Learning Material' className='w-full' />}
        </div>
    );
}
